var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiamond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "400px",
    height: "358px",
    viewBox: "0 0 400 358",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(-1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.9,357.884375 C195.028125,357.884375 189.454687,355.235938 185.714062,350.660938 L5.8296875,130.83125 C0.315625,124.09375 -0.19375,114.514063 4.571875,107.220313 L68.7703125,8.9359375 C72.4125,3.3578125 78.5953125,5.68434189e-14 85.2125,5.68434189e-14 L316.589063,5.68434189e-14 C323.207812,5.68434189e-14 329.385938,3.3578125 333.035937,8.9359375 L397.228125,107.220313 C401.995313,114.515625 401.484375,124.09375 395.970313,130.83125 L216.085938,350.659375 C212.345312,355.235938 206.773437,357.884375 200.9,357.884375 Z",
    id: "Path",
    fill: "#37C4B3",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.507812, 1.562500)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2640625,2.196875 C73.278125,3.7328125 70.6734375,6.0203125 68.771875,8.934375 L4.5703125,107.221875 C2.140625,110.942187 1.0875,115.260937 1.36875,119.496875 L152.884375,119.496875 L76.2640625,2.196875 Z",
    id: "Path",
    fill: "#53E7D3",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.9125,119.49375 L400.432813,119.49375 C400.7125,115.259375 399.664062,110.942187 397.229688,107.21875 L333.029688,8.934375 C331.128125,6.0203125 328.526563,3.734375 325.5375,2.196875 L248.9125,119.49375 Z",
    id: "Path",
    fill: "#53E7D3",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#53E7D3",
    fillRule: "nonzero",
    points: "200.9 357.925 279.067188 119.49375 123.217187 119.49375"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#B9F5ED",
    fillRule: "nonzero",
    points: "200.785937 5.68434189e-14 122.732812 119.49375 279.067188 119.49375 201.0125 5.68434189e-14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.284375,130.83125 C52.7703125,124.09375 52.259375,114.514063 57.0234375,107.220313 L121.225,8.9359375 C124.867187,3.3578125 131.051562,5.68434189e-14 137.667187,5.68434189e-14 L85.2109375,5.68434189e-14 C78.59375,5.68434189e-14 72.4109375,3.3578125 68.76875,8.9359375 L4.5703125,107.220313 C-0.1953125,114.515625 0.3140625,124.09375 5.828125,130.83125 L185.714062,350.660937 C189.454687,355.235938 58.284375,130.83125 58.284375,130.83125 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/diamond.e9899fe07a8237121328375d89c06208.svg";
export { ForwardRef as ReactComponent };